import { getApiUrl } from 'utils';

/**
 * Work-order / form photos live in the `photos` table as data URLs.
 * Served by GET xxy23oppsrt/:organizationId/:photoId — not the GCS images bucket.
 */
export const buildPhotosTableSrc = (
  organizationId: string | number | null | undefined,
  photoId: string | null | undefined,
): string => {
  const org = String(organizationId ?? '').trim();
  const id = String(photoId ?? '').trim();
  if (!org || !id || id.startsWith('data:image/')) return '';
  return `${getApiUrl()}xxy23oppsrt/${encodeURIComponent(org)}/${encodeURIComponent(id)}`;
};
